import type { EditPartResolvedScreen, ResolveEditPartScreenInput } from "~/features/addToCart/flow/types";

export function resolveEditPartScreen({ descriptorFacts }: ResolveEditPartScreenInput): EditPartResolvedScreen {
  if (descriptorFacts.isLoaded) {
    return "defaultForm";
  }

  if (descriptorFacts.isError) {
    return "errorLoading";
  }

  return "loading";
}
